import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mt-10 grid grid-cols-4 gap-7 border-t border-white pb-20 pt-10 xl:mt-14 2xl:grid-cols-6"
};
const _hoisted_2 = {
    key: 0,
    class: "relative z-0 col-span-3 2xl:col-span-4"
};
const _hoisted_3 = { class: "flex gap-7" };
const _hoisted_4 = ["href", "target", "rel"];
const _hoisted_5 = {
    key: 1,
    class: "2xl:col-span-2"
};
const _hoisted_6 = ["href"];
const _hoisted_7 = {
    key: 1,
    class: "!font-jp font-bold"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'SecondaryNavigation',
    props: {
        navOpen: {
            type: Boolean,
            required: false,
            default: false,
        },
        navigation: {
            type: Object,
            required: true,
        },
        japaneseText: {
            type: String,
            required: true,
        },
        japaneseLink: {
            type: Object,
            required: true,
        },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, {
                "enter-active-class": "slide-up__enter-active !delay-500",
                "enter-from-class": "slide-up__enter-from",
                "enter-to-class": "slide-up__enter-to",
                "leave-active-class": "slide-up__enter-active",
                "leave-from-class": "slide-up__enter-to",
                "leave-to-class": "slide-up__enter-from"
            }, {
                default: _withCtx(() => [
                    (__props.navOpen)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            (__props.navigation)
                                ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
                                    _createElementVNode("ul", _hoisted_3, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.navigation, (navItem) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: navItem.objectID,
                                                class: "basis-full text-sm font-bold"
                                            }, [
                                                _createElementVNode("a", {
                                                    href: navItem.url,
                                                    target: navItem.target || '_self',
                                                    rel: navItem.target === '_blank'
                                                        ? 'noopener noreferrer'
                                                        : null
                                                }, _toDisplayString(navItem.label), 9, _hoisted_4)
                                            ]));
                                        }), 128))
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (__props.japaneseText)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    (__props.japaneseLink)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "!font-jp font-bold",
                                            href: __props.japaneseLink.url
                                        }, _toDisplayString(__props.japaneseText), 9, _hoisted_6))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.japaneseText), 1))
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
